'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iBem = require('../../i-bem/i-bem.react');

var _iBem2 = _interopRequireDefault(_iBem);

var _bRadioboxERadio = (require('./../../radiobox/__radio/radiobox__radio.react.js').default || require('./../../radiobox/__radio/radiobox__radio.react.js')).applyDecls();

var _bRadioboxERadio2 = _interopRequireDefault(_bRadioboxERadio);

var _eControl = (require('./../__control/radio-button__control.react.js').default || require('./../__control/radio-button__control.react.js')).applyDecls();

var _eControl2 = _interopRequireDefault(_eControl);

void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)(_bRadioboxERadio2.default, {
    block: 'radio-button',
    elem: 'radio',
    willInit: function willInit() {
        this.__base.apply(this, arguments);

        this.setReference = this.setReference.bind(this);
        this.onClick = this.onClick.bind(this);
    },
    attrs: function attrs(_ref) {
        var style = _ref.style;

        return _extends({}, this.__base.apply(this, arguments), {
            style: style
        });
    },
    mods: function mods(_ref2) {
        var side = _ref2.side,
            onlyIcon = _ref2.onlyIcon;

        return _extends({}, this.__base.apply(this, arguments), {
            'only-icon': this.__self.bool2string(onlyIcon),
            side: side
        });
    },
    content: function content(_ref3) {
        var children = _ref3.children,
            value = _ref3.value,
            mainValue = _ref3.mainValue,
            onlyIcon = _ref3.onlyIcon,
            disabled = _ref3.disabled,
            _ref3$id = _ref3.id,
            id = _ref3$id === undefined ? this.generateId() : _ref3$id,
            name = _ref3.name,
            onChange = _ref3.onChange;

        var content = [_react2.default.createElement(_eControl2.default, _extends({ key: 'control' }, {
            id: id,
            name: name,
            value: value,
            onChange: onChange,
            disabled: disabled,
            innerRef: this.setReference,
            onClick: disabled ? undefined : this.onClick,
            checked: this._isChecked(value, mainValue) }))];

        if (onlyIcon) {
            return content.concat('\xA0', children);
        }

        return content.concat(_react2.default.createElement(
            _iBem2.default,
            {
                key: 'text',
                block: this.block,
                elem: 'text',
                tag: 'span' },
            children
        ));
    },
    setReference: function setReference(control) {
        this.control = control;
    },
    onClick: function onClick(event) {
        this.control.focus();
        this.props.onClick && this.props.onClick(event);
    }
}, {
    isRadio: function isRadio(child) {
        return child.type && child.type.displayName === 'radio-button__radio';
    }
});